import { useState } from "react";

interface PriceItemData {
    service: string;
    price: string;
    describe: string;
    detail?: string;
}
type PriceItemProps = {
    item: PriceItemData;
};
export default function PriceItem({ item }: PriceItemProps) {
    const [open, setOpen] = useState(false);

    return (
        <li className={`cs-menu-item ${open ? "open" : ""}`}>
            <h3 className="cs-h3">
                <span className="cs-header">{item.service}</span>
                <span className="cs-price">{item.price}</span>
            </h3>

            <div
                className={`cs-menu-summary ${item.detail ? "is-clickable" : "is-static"}`}
                role={item.detail ? "button" : undefined}
                tabIndex={item.detail ? 0 : undefined}
                aria-expanded={item.detail ? open : undefined}
                onClick={item.detail ? () => setOpen(!open) : undefined}
                onKeyDown={
                    item.detail
                        ? (e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                setOpen(!open);
                            }
                        }
                        : undefined
                }
            >
                <p className={`cs-menu-text ${item.detail ? "" : "no-detail"}`}>
                    {item.describe}
                </p>
                {item.detail && (
                    <svg className="cs-chevron" viewBox="0 0 20 20">
                        <path d="M6 9l6 6 6-6" />
                    </svg>
                )}

            </div>
            {item.detail && (
                <div className="cs-menu-detail">
                    {item.detail.split("\n").map((line: string, i: number) => (
                        <p className="pricer-detail" key={i}>{line}</p>
                    ))}
                </div>
            )}
        </li>
    );
}